export default {
  title: '',
  jobIds: null,
  companies: [],
  checkedCompanyIds: [],
  selectedJobIds: [],
  rootCompanyId: null,
  underLine: {
    title: {
      isShow: true,
      width: '70px', // any number with px, compute(bigger than text), full(line/screen)
      color: null
    }
  },
  styleConfig: {
    root: null
    // title: {
    //   fontSize: '32px',
    //   color: '#000'
    // }
  }
}
